import { AppState } from 'pages/app/state';
import { connect } from 'react-redux';
import { Props, OperationCount } from './component';
import { getCurrentClientTransactionIds } from '../selectors';
import { languageSelector } from 'pages/settings/selectors';

function mapStateToProps(state: AppState): Props {
  return {
    language: languageSelector(state),
    count: getCurrentClientTransactionIds(state).length
  };
}

export default connect(mapStateToProps)(OperationCount);


// WEBPACK FOOTER //
// ./src/components/operation-grid/operation-count/index.ts